import { Link, Outlet } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Logo from "@/components/Logo";
import { useSettings } from "@/context/SettingsContext";

function Footer() {
  const { settings } = useSettings();
  const contact = settings?.contact || {};
  return (
    <footer className="bg-[#0B0F17] text-slate-400" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5 space-y-4">
          <Logo dark />
          <p className="text-sm max-w-sm leading-relaxed" data-testid="footer-about">{settings?.footer_about}</p>
        </div>
        <div className="md:col-span-3 space-y-3 text-sm">
          <p className="text-white font-semibold font-display">Informasi</p>
          <Link to="/program" className="block hover:text-amber-400" data-testid="footer-program-link">Program Belajar</Link>
          <Link to="/kebijakan-privasi" className="block hover:text-amber-400" data-testid="footer-privacy-link">Kebijakan Privasi</Link>
          <Link to="/syarat-layanan" className="block hover:text-amber-400" data-testid="footer-terms-link">Syarat Layanan</Link>
          <Link to="/kontak" className="block hover:text-amber-400" data-testid="footer-contact-link">Kontak</Link>
        </div>
        <div className="md:col-span-4 space-y-3 text-sm">
          <p className="text-white font-semibold font-display">Hubungi Kami</p>
          <p className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-amber-500" />{contact.address}</p>
          <p className="flex gap-2"><Phone className="h-4 w-4 mt-0.5 shrink-0 text-amber-500" />{contact.whatsapp}</p>
          <p className="flex gap-2"><Mail className="h-4 w-4 mt-0.5 shrink-0 text-amber-500" />{contact.email}</p>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-center text-xs" data-testid="footer-copyright">{settings?.footer_copyright}</div>
    </footer>
  );
}

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}
